<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer id="mat-sidenav" class="sidenav" fixedInViewport="true" [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="!(isHandset$ | async)">
    <mat-toolbar color="primary">
      <div class="no-action" *ngIf="notVerify"></div>
      <a class="navbar-brand mr-auto" [routerLink]="['/client/dashboard']">
        <img *imageWithBrandPrefix="'assets/images/Client_Portal_Logo.png'" align="center" class="navbar-brand-logo" alt="" />
      </a>
    </mat-toolbar>
    <mat-nav-list class="d-block d-md-none">
      <div class="no-action" *ngIf="notVerify"></div>
      <a mat-list-item routerLink="/client/dashboard" routerLinkActive="active-link" (click)="drawer.toggle()">
        <img src="assets/images/dashboard-icon/dashboardicn.svg" align="center" alt="" /> Dashboard
      </a>

      <a mat-list-item (click)="showSubMenu()">
        <img src="assets/images/dashboard-icon/paymentsicn.svg" align="center" alt="" /> Payment
      </a>
      <div class="sub-menu-payment" [hidden]="showHideSubMenu">
        <a class="pl-4" mat-list-item routerLink="/client/payment/internal-transfer" routerLinkActive="active-link" *ngIf="approvedForInternalTransfers && userDetail.clientRole !== userRoleEnum.ReadOnly">
          <img src="assets/images/dashboard-icon/paymentsicn.svg" align="center" alt="" /> Transfer
        </a>
        <a class="pl-4" mat-list-item routerLink="/client/payment/payment-history" routerLinkActive="active-link" (click)="drawer.toggle()">
          <img src="assets/images/dashboard-icon/paymentsicn.svg" align="center" alt="" /> Payment History
        </a>
        <ng-container *ngIf="userDetail && userDetail.paymentFileImport">
          <div class="pl-4">
            <a mat-list-item (click)="togglePaymentImportSubMenu()">
              <img src="assets/images/dashboard-icon/paymentsicn.svg" align="center" alt="" /> Payment File Import
            </a>
            <div class="pl-4" [hidden]="!showPaymentImportSubMenu">
              <a mat-list-item routerLink="/client/payment/payment-import" routerLinkActive="active-link">
                <img src="assets/images/dashboard-icon/paymentsicn.svg" align="center" alt="" /> Pay from Balance
              </a>
              <a *ngIf="userDetail.payFromNewFxTrades" mat-list-item routerLink="/client/payment/payment-import-fx" routerLinkActive="active-link">
                <img src="assets/images/dashboard-icon/paymentsicn.svg" align="center" alt="" /> Pay from New FX Trade(s)
              </a>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="registrationStep2Service.dualAuthorization && (registrationStep2Service.userRole === userRoleEnum.Administrator || registrationStep2Service.userRole === userRoleEnum.Validator)">
          <a class="pl-4" mat-list-item routerLink="/client/payment/pending-payment-file" routerLinkActive="active-link" (click)="drawer.toggle()">
            <img src="assets/images/dashboard-icon/paymentsicn.svg" align="center" alt="" /> Pending Payment File Approvals
          </a>
        </ng-container>
        <ng-container *ngIf="registrationStep2Service.dualAuthorization">
          <a class="pl-4" mat-list-item routerLink="/client/payment/pending-payment-approval" routerLinkActive="active-link" (click)="drawer.toggle()">
            <img src="assets/images/dashboard-icon/paymentsicn.svg" align="center" alt="" /> Pending Payment Approvals
          </a>
        </ng-container>
        <ng-container *ngIf="registrationStep2Service.transferDualAuthorization">
          <a class="pl-4" mat-list-item routerLink="/client/payment/pending-transfer-approval" routerLinkActive="active-link" *ngIf="approvedForInternalTransfers">
            <img src="assets/images/dashboard-icon/paymentsicn.svg" align="center" alt="" /> Pending Transfer Approvals
          </a>
        </ng-container>
        <a class="pl-4" mat-list-item routerLink="/client/manage-recipient" routerLinkActive="active-link" (click)="drawer.toggle()">
          <img src="assets/images/dashboard-icon/paymentsicn.svg" align="center" alt="" /> Manage Beneficiaries
        </a>
        <a *ngIf="userDetail?.fullRemitterDetailsRequired" class="pl-4" mat-list-item routerLink="/client/manage-ultimate-remitters" routerLinkActive="active-link" (click)="drawer.toggle()">
          <img src="assets/images/dashboard-icon/paymentsicn.svg" align="center" alt="" /> Manage Ultimate Remitters
        </a>
        <a class="pl-4" mat-list-item routerLink="/client/trade-history" routerLinkActive="active-link" (click)="drawer.toggle()">
          <img src="assets/images/dashboard-icon/paymentsicn.svg" align="center" alt="" /> Trade History
        </a>
        <a class="pl-4" mat-list-item routerLink="/client/approved-payers" routerLinkActive="active-link" (click)="drawer.toggle()">
          <img src="assets/images/dashboard-icon/paymentsicn.svg" align="center" alt="" /> ApprovedPayers
        </a>
      </div>


      <a mat-list-item routerLink="/client/add-drawdown" routerLinkActive="active-link" (click)="drawer.toggle()">
        <img src="assets/images/dashboard-icon/drawdownicn.png" align="center" alt="" /> Add Drawdown
      </a>

      <a mat-list-item routerLink="/client/statement-report" routerLinkActive="active-link" (click)="drawer.toggle()">
        <img src="assets/images/dashboard-icon/statementicn.svg" align="center" alt="" /> Statement Report
      </a>
    </mat-nav-list>

    <mat-nav-list class="d-none d-md-block">
      <div class="no-action" *ngIf="notVerify"></div>
      <a mat-list-item routerLink="/client/dashboard" routerLinkActive="active-link">
        <img src="assets/images/dashboard-icon/dashboardicn.svg" align="center" alt="" /> Dashboard
      </a>

      <a mat-list-item (click)="showSubMenu()">
        <img src="assets/images/dashboard-icon/paymentsicn.svg" align="center" alt="" /> Payment
      </a>
      <div class="sub-menu-payment" [hidden]="showHideSubMenu">
        <a class="pl-4" mat-list-item routerLink="/client/payment/internal-transfer" routerLinkActive="active-link" *ngIf="approvedForInternalTransfers && userDetail.clientRole !== userRoleEnum.ReadOnly">
          <img src="assets/images/dashboard-icon/paymentsicn.svg" align="center" alt="" /> Transfer
        </a>
        <a class="pl-4" mat-list-item routerLink="/client/payment/payment-history" routerLinkActive="active-link">
          <img src="assets/images/dashboard-icon/paymentsicn.svg" align="center" alt="" /> Payment History
        </a>
        <ng-container *ngIf="userDetail && userDetail.paymentFileImport">
          <div class="pl-4">
            <a mat-list-item (click)="togglePaymentImportSubMenu()">
              <img src="assets/images/dashboard-icon/paymentsicn.svg" align="center" alt="" /> Payment File Import
            </a>
            <div class="pl-4" [hidden]="!showPaymentImportSubMenu">
              <a mat-list-item routerLink="/client/payment/payment-import" routerLinkActive="active-link">
                <img src="assets/images/dashboard-icon/paymentsicn.svg" align="center" alt="" /> Pay from Balance
              </a>
              <a *ngIf="userDetail.payFromNewFxTrades" mat-list-item routerLink="/client/payment/payment-import-fx" routerLinkActive="active-link">
                <img src="assets/images/dashboard-icon/paymentsicn.svg" align="center" alt="" /> Pay from New FX Trade(s)
              </a>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="registrationStep2Service.dualAuthorization && (registrationStep2Service.userRole === userRoleEnum.Administrator || registrationStep2Service.userRole === userRoleEnum.Validator)">
          <a class="pl-4" mat-list-item routerLink="/client/payment/pending-payment-file" routerLinkActive="active-link">
            <img src="assets/images/dashboard-icon/paymentsicn.svg" align="center" alt="" /> Pending Payment File Approvals
          </a>
        </ng-container>
        <ng-container *ngIf="registrationStep2Service.dualAuthorization">

          <a class="pl-4" mat-list-item routerLink="/client/payment/pending-payment-approval" routerLinkActive="active-link">
            <img src="assets/images/dashboard-icon/paymentsicn.svg" align="center" alt="" /> Pending Payment Approvals
          </a>
        </ng-container>

        <ng-container *ngIf="registrationStep2Service.transferDualAuthorization">
          <a class="pl-4" mat-list-item routerLink="/client/payment/pending-transfer-approval" routerLinkActive="active-link" *ngIf="approvedForInternalTransfers">
            <img src="assets/images/dashboard-icon/paymentsicn.svg" align="center" alt="" /> Pending Transfer Approvals
          </a>
        </ng-container>

        <a class="pl-4" mat-list-item routerLink="/client/manage-recipient" routerLinkActive="active-link">
          <img src="assets/images/dashboard-icon/paymentsicn.svg" align="center" alt="" /> Manage Beneficiaries
        </a>
        <a *ngIf="userDetail?.fullRemitterDetailsRequired" class="pl-4" mat-list-item routerLink="/client/manage-ultimate-remitters" routerLinkActive="active-link">
          <img src="assets/images/dashboard-icon/paymentsicn.svg" align="center" alt="" /> Manage Ultimate Remitters
        </a>
        <a class="pl-4" mat-list-item routerLink="/client/trade-history" routerLinkActive="active-link">
          <img src="assets/images/dashboard-icon/paymentsicn.svg" align="center" alt="" /> Trade History
        </a>
        <a class="pl-4" mat-list-item routerLink="/client/approved-payers" routerLinkActive="active-link" (click)="drawer.toggle()">
          <img src="assets/images/dashboard-icon/paymentsicn.svg" align="center" alt="" /> ApprovedPayers
        </a>
      </div>

      <a mat-list-item routerLink="/client/add-drawdown" routerLinkActive="active-link">
        <img src="assets/images/dashboard-icon/drawdownicn.png" align="center" alt="" /> Add Drawdown
      </a>

      <a mat-list-item routerLink="/client/statement-report" routerLinkActive="active-link">
        <img src="assets/images/dashboard-icon/statementicn.svg" align="center" alt="" /> Statement Report
      </a>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar color="primary">
      <button type="button" id="showHideNav" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <div class="d-none d-md-inline-block">
        <span class="nav-header text-fw-700">Client Dashboard |&nbsp;</span>
        <span class="nav-header">{{ userInfo.accountName }} - ID: {{ userInfo.accountNumber }}</span>
        &nbsp;
        <span *ngIf="userDetail && userDetail.clientRole === userRoleEnum.ReadOnly" class="nav-header">(Read only)</span>
      </div>
      <div class="d-inline-block d-md-none">
        <span class="nav-header text-fw-700">Client Dashboard |&nbsp;</span>
        <span class="nav-header">{{ userInfo.accountName }}...</span>
        <span *ngIf="userDetail && userDetail.clientRole === userRoleEnum.ReadOnly" class="nav-header">(Read only)</span>
      </div>

      <div class="account-info-mobile--wrapper d-block d-md-none ml-auto">
        <img class="img-user-menu target-click" *imageWithBrandPrefix="'/assets/images/icon-png/user.png'" (click)="showMenu()" alt="" />
        <ul #menu class="menu-user" [hidden]="showHideMenu">
          <li class="user-name">{{ userInfo.fullName }}</li>
          <li class="user-role">{{userRoleName}}</li>
          <li>
            <a class="navigation-link" (click)="hideMenu()" routerLink="/client/client-profile" [class.disabled]="notVerify">Profile</a>
          </li>
          <li>
            <a class="navigation-link" (click)="hideMenu()" routerLink="/client/change-memorable-number" [class.disabled]="notVerify">Change Memorable Number</a>
          </li>
          <li>
            <a class="navigation-link" (click)="hideMenu()" routerLink="/client/change-password" [class.disabled]="notVerify">Change Password</a>
          </li>
          <ng-container *ngIf="userDetail && userDetail.leadType !== leadTypeEnum.Private && userDetail.clientRole === userRoleEnum.Administrator">
            <li>
              <a class="navigation-link" (click)="hideMenu()" routerLink="/client/user-management" [class.disabled]="notVerify">User Management</a>
            </li>
          </ng-container>
          <li>
            <a class="navigation-link" (click)="logout()">Log out</a>
          </li>
        </ul>
      </div>

      <div class="menu-right d-none d-md-block">
        <ul class="main-dropdown-menu">
          <li *ngIf="showAccountSelection" class="accountSelectionDropDown"> 
            <np-mat-select-hybrid label="Select account" 
                                  [selectControl]="profileSwitchingForm.get('account')"
                                  [data]="profiles" dataKey="leadId" dataDisplayValue="leadName"
                                  (selectionChanged)="changeProfile()">
            </np-mat-select-hybrid>
          </li>
          <li>
            <img class="img-user-menu target-click" *imageWithBrandPrefix="'/assets/images/icon-png/user.png'" (click)="showMenu()" alt="" />
            <ul #menu class="menu-user" [hidden]="showHideMenu">
              <ul class="sub-menu-user">
                <li class="user-name">{{ userInfo.fullName }} </li>
                <li class="user-role">{{userRoleName}}</li>
              </ul>
              <li>
                <a class="navigation-link" (click)="hideMenu()" routerLink="/client/client-profile" [class.disabled]="notVerify">Profile</a>
              </li>
              <li>
                <a class="navigation-link" (click)="hideMenu()" routerLink="/client/change-memorable-number" [class.disabled]="notVerify">Change Memorable Number</a>
              </li>
              <li>
                <a class="navigation-link" (click)="hideMenu()" routerLink="/client/change-password" [class.disabled]="notVerify">Change Password</a>
              </li>
              <ng-container *ngIf="userDetail && userDetail.leadType !== leadTypeEnum.Private && userDetail.clientRole === userRoleEnum.Administrator">
                <li>
                  <a class="navigation-link" (click)="hideMenu()" routerLink="/client/user-management" [class.disabled]="notVerify">User Management</a>
                </li>
              </ng-container>
              <li>
                <a class="navigation-link" (click)="logout()">Log out</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </mat-toolbar>
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>
